import PropTypes from "prop-types";

import Rating from "@mui/material/Rating";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

/**
 * Batch 3.2 — <StarRating> (D9). A 1–5 star selector. Controlled by a numeric
 * `value` (0 = unrated); clicking the active rating again clears it.
 */
function StarRating({ value, onChange, label }) {
  const rating = value || 0;

  return (
    <MDBox>
      {label && (
        <MDTypography variant="button" fontWeight="medium" display="block" mb={0.5}>
          {label}
        </MDTypography>
      )}
      <Rating value={rating} max={5} onChange={(event, next) => onChange(next || 0)} />
    </MDBox>
  );
}

StarRating.defaultProps = {
  value: 0,
  label: "Rating",
};

StarRating.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};

export default StarRating;
